import React from 'react';
import { useLoadingController } from './hooks/use-loading';
import { Box, Title } from '@src/shared/ui';
import Lottie from 'lottie-react';
import loadingJson from './loadingJson.json';
import { motion } from 'framer-motion';

export const LoadingPage: React.FC = () => {
  useLoadingController();

  return (
    <Box className='h-svh w-svw m-0 p-0 bg-brand-blue-midnight-30 text-neutral-0 justify-center items-center flex flex-col overflow-hidden fixed'>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 1, ease: 'easeInOut' }}
      >
        <Lottie
          className='self-start sm:self-center h-[62px] sm:h-[72px] mb-8 ml-6'
          animationData={loadingJson}
          loop={true}
        />
        <Title
          className={`
          text-[20px]
          font-semibold
          sm:text-[32px]
          text-left
          sm:text-center
          text-neutral-0
          max-w-[624px]
          mx-8
          sm:mx-[105px]
        `}
        >
          Por favor, aguarde. Estamos gerando o boleto para pagamento da
          entrada.
        </Title>
      </motion.div>
      <img
        src='/background-feedback.svg'
        alt='Pagol background'
        className={`
          overflow-hidden
          opacity-10
          absolute
          min-w-[140%]
          sm:min-w-max
          top-[70%]
          md:-mb-20
          align-bottom
          px-[-25%]
          sm:w-[100%]
          md:top-[30%]
          md:translate-x-2/3
          md:w-[850px]
      `}
      />
    </Box>
  );
};
